import { parseConsentClauseIds } from "./deliveryConsent";

export function isExpired(expiryUtcSeconds) {
    return Date.now() >= expiryUtcSeconds * 1000;
}

export function buildVideoReviewUrl(token) {
    const { origin, pathname } = window.location;
    const base = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return `${origin}${base}/#/v/${token}`;
}

export function getVideoName(payload, fallback) {
    if (payload?.n) {
        return payload.n;
    }
    return fallback || "";
}

export function getVideoPath(payload) {
    return payload?.v || "";
}

export function getCommentVisibility(payload) {
    return payload?.cv === "individual" ? "individual" : "shared";
}

export function getConsentClauseIds(payload) {
    return parseConsentClauseIds(payload?.c);
}

export function getConsentKey(token) {
    return `video-review-consent:${token}`;
}

export function hasConsent(token) {
    try {
        return sessionStorage.getItem(getConsentKey(token)) === "1";
    } catch {
        return false;
    }
}

export function setConsent(token) {
    try {
        sessionStorage.setItem(getConsentKey(token), "1");
    } catch {
        // sessionStorage unavailable
    }
}

export function getReviewerNameKey(token) {
    return `video-review-name:${token}`;
}

export function getReviewerName(token) {
    try {
        return sessionStorage.getItem(getReviewerNameKey(token)) || "";
    } catch {
        return "";
    }
}

export function setReviewerName(token, name) {
    try {
        sessionStorage.setItem(getReviewerNameKey(token), name);
    } catch {
        // sessionStorage unavailable
    }
}
